import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import './_lastFatturaGas.scss'
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { DateTime } from 'luxon';
import { ReactComponent as Check } from '../../assets/new-icons/check_simple.svg';
import { ReactComponent as Close } from '../../assets/new-icons/close.svg';


function LastFatturaGas() {
    const customerCode = useSelector((user) => user.gas?.info?.customer_code);
    const [fatture, setFatture] = useState(null)
    useEffect(() => {
        init()
    }, [customerCode])
    const init = async () => {
        const api = `https://my.revoluce.it/area_utente/gestione/api/deliveries/getFattureGas.php?codice_cliente=${customerCode}`
        const { data } = await axios.get(api)
        setFatture(data[0])
    }
    return (
        <>
            {fatture && (
                <div className='lastFattura'>
                    <div className="iconWrap">
                        <div className="icon">
                            {fatture && fatture.stato_pagamento !== "0" ? (
                                <Check fill='#5AD8A6' />
                            ) : (
                                <Close fill='#FF5668' />
                            )}
                        </div>
                    </div>
                    <div className="info">
                        <p className='date'>{fatture && DateTime.fromISO(fatture.data_emissione).toFormat('d.MM.y')}</p>
                        <p className="title">Fattura {fatture && DateTime.fromISO(fatture.mese_fattura).toFormat('MMM y')}</p>
                        <p className="detail">{fatture && fatture.numero_fattura}</p>
                        <p className="price">{fatture && parseFloat(fatture.totale_fattura).toFixed(2).replace(/\./g, ",")} €</p>
                    </div>
                    <div className="download" onClick={() =>  fatture && window.open(`${fatture.url}`, "_blank")}>
                        <FileDownloadIcon />
                        <p>Scarica</p>
                    </div>
                </div>
            )}
        </>
    )
}

export default LastFatturaGas